module.exports = __webpack_public_path__ + "img/Buybox Monitor.e9777254.svg";